import React from 'react';
import { trackQuizCTAClick } from '../../mixpanel/events';

const QuizScore = ({ displayedPercentage, scoreMessage, showCallToAction }) => {
  const handleCTAClick = () => {
    trackQuizCTAClick();
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-apple-gray-100 p-8 rounded-lg text-center">
        <div className="mb-4">
          <div className="text-4xl font-bold text-apple-gray-800 mb-2">
            {displayedPercentage}%
          </div>
        </div>

        <div className="mb-6">
          <p className="text-lg font-medium text-apple-gray-800 mb-4">
            {scoreMessage}
          </p>

          <div
            hidden={!showCallToAction}
            className={`bg-white p-6 rounded-lg border border-apple-gray-200 transition-all duration-500 ease-in-out ${showCallToAction
              ? 'opacity-100 transform translate-y-0'
              : 'opacity-0 max-h-0 transform -translate-y-4 overflow-hidden'
              }`}
          >
            <div className="flex items-center justify-center mb-4">
              <div className="bg-apple-gray-800 p-3 rounded-lg mr-4">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              <h4 className="text-lg font-semibold text-apple-gray-800">Don't Let Technical Gaps Sink Your Startup</h4>
            </div>
            <p className="text-apple-gray-600 mb-6">
              Every "No" represents a potential 6-7 figure mistake waiting to happen. Get the technical guidance you need before it's too late.
            </p>
            <a
              href="https://form.typeform.com/to/SLoI0dkA"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCTAClick}
              className="inline-block bg-apple-gray-800 text-white font-semibold py-3 px-6 rounded-lg hover:bg-apple-gray-700 transition-colors duration-200"
            >
              Get Technical Leadership Help
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizScore;